import { ReactElement, ReactNode, useMemo, useRef } from 'react';

import { useImprvApi } from '@hooks/useImprvApi';
import { BackgroundActivityRegistry } from '@services/backgroundActivityRegistry';
import { MediaitemUploadService } from '@services/mediaitemUploadService';

import {
  BackgroundActivityRegistryContext,
  MediaitemUploadServiceContext
} from './BackgroundActivityContext';

function BackgroundActivityProvider({ children }: { children: ReactNode }): ReactElement {
  const api = useImprvApi();
  const registryRef = useRef<BackgroundActivityRegistry | null>(null);
  if (!registryRef.current) {
    registryRef.current = new BackgroundActivityRegistry();
  }
  const uploadService = useMemo(
    () => new MediaitemUploadService({ api, registry: registryRef.current! }),
    [api]
  );
  return (
    <BackgroundActivityRegistryContext.Provider value={registryRef.current}>
      <MediaitemUploadServiceContext.Provider value={uploadService}>
        {children}
      </MediaitemUploadServiceContext.Provider>
    </BackgroundActivityRegistryContext.Provider>
  );
}

export default BackgroundActivityProvider;
